async function getCart() {
  if (window.cartLines) {
    return window.cartLines;
  }

  const res = await fetch('/cart.js');
  if (res.status === 200) {
    try {
      const cart = await res.json();
      window.cartLines = [...cart.items].reverse();
    } catch (e) {
      window.cartLines = [];
    }
  }

  return window.cartLines;
}

function cartEvent(cart, eventData) {
  let total_price = 0;
  let total_discount = 0;
  let original_total_price = 0;
  for (const line of cart) {
    total_price += line.final_line_price;
    total_discount += line.line_level_total_discount;
    original_total_price += line.original_line_price;
  }
  const event = {
    ...eventData,
    total_price: total_price / 100,
    $value: total_price / 100,
    total_discount: total_discount / 100,
    original_total_price: original_total_price / 100,
    items: cart,
  };
  return event;
}

async function updateCart(cart, options) {
  const modifiedCart = cart.map(line => (typeof line.id === 'string' ? { ...line, id: parseInt(line.id) } : line));
  const redraft = await SMMFetch('POST', '/cart/prepare-cart', modifiedCart, undefined, true);
  let newCart = redraft.cart;

  await fetch('/cart/clear.js', { method: 'POST' });

  const body = {
    items: [...newCart].reverse(),
    ...options,
  };

  if (newCart.length === 0) {
    location.reload();
    return;
  }

  const data = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then(res => res.json());

  window.cartLines = [...data.items].reverse();

  return data;
}

async function refreshCart() {
  const payload = await updateCart(await getCart(), undefined);

  const event = cartEvent(payload.items, {});
  var _learnq = window._learnq || [];
  _learnq.push(['track', 'Cart Refreshed', event]);

  return payload;
}

async function addToCart(add, options) {
  const cartLines = await getCart();

  const payload = await updateCart([...cartLines, ...add], options);

  const event = cartEvent(payload.items, { added_items: add });
  var _learnq = window._learnq || [];
  _learnq.push(['track', 'Added to Cart', event]);

  return payload;
}

async function setCartQuantity(key, quantity, options) {
  const cartLines = await getCart();
  const line = cartLines?.find(line => line.key == key);

  if (!line) return;

  if (quantity > line.quantity) {
    return addToCart(
      [
        {
          ...line,
          quantity: quantity - line.quantity,
        },
      ],
      options,
    );
  } else {
    const quantity_reduced_by = line.quantity - quantity;
    line.quantity = quantity;

    const payload = await updateCart(cartLines, options);

    const event = cartEvent(payload.items, { updated_item: line, quantity_reduced_by });
    var _learnq = window._learnq || [];
    _learnq.push(['track', 'Removed from Cart', event]);

    return payload;
  }
}

function getCustomerId() {
  try {
    const data = document.getElementById('cart-context').innerHTML;
    return JSON.parse(data)?.customerId;
  } catch (e) {
    return 0;
  }
}

function showLoadingOverlay(text) {
  const overlay = document.createElement('div');
  overlay.setAttribute('style', 'display:block;position:fixed;left:0;right:0;top:0;bottom:0;z-index:1000;background:white;');
  overlay.innerHTML = `<h1 style="position:absolute;left:50%;top:50%;transform: translate(-50%, 50%);">${text}</h1><div class="spinner"></div>`;
  document.querySelector('main').appendChild(overlay);
  return overlay;
}

window.addEventListener('load', async function () {
  try {
    const cart = await getCart();
    // cart is empty so no refresh strategy is needed
    if (!cart.length) {
      return;
    }
    // if customer logs in from the cart we need to refresh the cart to show custom pricing
    if (window.getCookie('logged-in-cart') === 'true') {
      showLoadingOverlay('Updating pricing...');
      await refreshCart();
      window.setCookie('logged-in-cart', 'done', 24);
      location.reload();
    }
    // // if logged-in-cart cookie is set to done then the user was previously logged in and logged out so we should refresh cart to switch back to new customer pricing
    if (window.getCookie('logged-in-cart') === 'done' && !getCustomerId()) {
      await refreshCart();
      window.setCookie('logged-in-cart', 'false', 1);
      location.reload();
    }
    // if customer has a cart and logs in from the profile icon instead of in the cart we need to refresh the cart to show custom pricing
    if ((window.getCookie('logged-in-cart') === 'false' || !window.getCookie('logged-in-cart')) && getCustomerId()) {
      await refreshCart();
      window.setCookie('logged-in-cart', 'done', 1);
      location.reload();
    }
  } catch (e) {
    console.error(e);
    // if the user already bought device but is not logged in, then logs in and the device
    // in cart plus new device exceed max count, we need to clear the cart as a clean error
    // resolution rather than blocking the user completely.
    // await fetch('/cart/clear.js', { method: 'POST' });
    // location.reload();
  }
});

window.getCustomerId = getCustomerId;
window.updateCart = updateCart;
window.refreshCart = refreshCart;
window.addToCart = addToCart;
window.setCartQuantity = setCartQuantity;
window.getCart = getCart;
